import "../../../styles/gamification.css";

interface ProgressBarProps {
    progress: number;
    visible: boolean;
}

const TIMER_COLOUR_STOPS = [
    { r: 34, g: 197, b: 94 },
    { r: 245, g: 158, b: 11 },
    { r: 239, g: 68, b: 68 },
];

export const getTimerColor = (progress: number): string => {
    const scaled = (progress / 100) * 2;
    const idx = Math.min(Math.floor(scaled), 1);
    const t = scaled - idx;
    const eased = t * t * (3 - 2 * t);
    const from = TIMER_COLOUR_STOPS[idx];
    const to = TIMER_COLOUR_STOPS[idx + 1];
    const r = Math.round(from.r + (to.r - from.r) * eased);
    const g = Math.round(from.g + (to.g - from.g) * eased);
    const b = Math.round(from.b + (to.b - from.b) * eased);
    return `rgb(${r}, ${g}, ${b})`;
};

const ProgressBar = ({ progress, visible }: ProgressBarProps) => {
    if (!visible) return null;
    return (
        <div className="s2-progress-bar-track">
            <div
                className={`s2-progress-bar-fill ${progress >= 100 ? "s2-progress-bar-pulse" : ""}`}
                style={{
                    width: `${progress}%`,
                    backgroundColor: getTimerColor(progress),
                }}
            />
        </div>
    );
};

export default ProgressBar;
